<template>
  <div>
    <div class="select-container">
      <select
        :id="id"
        v-model="workStatus"
        :name="id"
      >
        <option
          v-for="status in statuses"
          :key="status.value"
          :value="status.value"
          v-text="status.title"
        />
      </select>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'WorkStatusField',
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: 'active',
    },
  },
  data() {
    return {
      statuses: [
        {
          title: 'Active Member',
          value: 'active',
        },
        {
          title: 'Auxiliary Member',
          value: 'auxiliary',
        },
        {
          title: 'Retired Member',
          value: 'retired',
        },
        {
          title: 'Non Member',
          value: 'non_member',
        },
        {
          title: 'Associate Member',
          value: 'associate_member',
        },
        {
          title: 'Military Leave',
          value: 'military_leave',
        },
        {
          title: 'Reserves',
          value: 'reserves',
        },
        {
          title: 'Quit',
          value: 'quit',
        },
        {
          title: 'Terminated',
          value: 'terminated',
        },
        {
          title: 'Deceased',
          value: 'deceased',
        },
        {
          title: 'Volunteer',
          value: 'volunteer',
        },
        {
          title: 'Spouse',
          value: 'spouse',
        },
        {
          title: 'Suspended',
          value: 'suspended',
        },
        {
          title: 'Transfer Pending',
          value: 'transfer_pending',
        },
        {
          title: 'Transferred Out',
          value: 'transferred_out',
        },
      ],
    }
  },
  computed: {
    workStatus: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
